import {
  type ContentObjectList,
  type ContentObjectView,
  type NonEventContentObjectDetail,
  isJournalNote,
} from 'models';
import { CommentBookmark } from '../../../comment-bookmark';
import { ActivityContentObject } from '../../activity-content-object';
import { EventContentObject } from '../../event-content-object';
import { GivingContentObject } from '../../giving-content-object';
import { JournalContentObject } from '../../journal-content-object';
import { KudoContentObject } from '../../kudo-content-object';
import { PollContentObject } from '../../poll-content-object';
import { PostContentObject } from '../../post-content-object';
import { WithingsOrderPostContentObject } from '../../withings-order-post-content-object';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const ContentObjectRendererComponent = ({ item, onShowComments, view }: P) => {
  switch (item.type) {
    case 'activity':
      return <ActivityContentObject item={item} onShowComments={onShowComments} view={view} />;
    case 'comment':
      return <CommentBookmark item={item} view={view} />;
    case 'event':
      return <EventContentObject item={item} onShowComments={onShowComments} view={view} />;
    case 'giving':
      return <GivingContentObject item={item} onShowComments={onShowComments} view={view} />;
    case 'kudo':
      return <KudoContentObject item={item} onShowComments={onShowComments} view={view} />;
    case 'poll':
      return <PollContentObject item={item} onShowComments={onShowComments} view={view} />;
    case 'post':
      return isJournalNote(item) ? (
        <JournalContentObject item={item} onShowComments={onShowComments} view={view} />
      ) : (
        <PostContentObject item={item} onShowComments={onShowComments} view={view} />
      );
    case 'video':
      throw new Error(`Not implemented yet: ${item.type} case`);
    case 'withings_order_post':
      return <WithingsOrderPostContentObject item={item} onShowComments={onShowComments} view={view} />;
  }
};

export default ContentObjectRendererComponent;
